import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getGDSNSchema } from 'services/product';
import * as productServices from 'services/product';

const getGDSNReceivedProductQueryKey = (id) => [
  'gdsn',
  'get-gdsn-received-product-detail',
  Number(id),
];
const getAllGDSNReceivedProductQueryKey = () => [
  'gdsn',
  'get-gdsn-received-product-detail',
];
const getGDSNSchemaQueryKey = () => ['get-gdsn-schema'];

export const useGetGDSNReceivedProductDetail = ({ id, enabled }) => {
  const queryClient = useQueryClient();

  const queries = useQuery({
    queryKey: getGDSNReceivedProductQueryKey(id),
    queryFn: async () => {
      const response = await productServices.getGDSNReceivedProductDetail({
        id,
      });
      if (response?.isSuccess) {
        return response?.data;
      } else {
        throw new Error(response?.message);
      }
    },
    enabled: enabled,
    retry: false,
  });
  const invalidateGDSNReceivedProductDetail = () => {
    queryClient.invalidateQueries({
      queryKey: getGDSNReceivedProductQueryKey(id),
    });
  };

  return {
    ...queries,
    invalidateGDSNReceivedProductDetail,
  };
};

export const useGetGDSNSchema = () => {
  const queries = useQuery({
    queryKey: getGDSNSchemaQueryKey(),
    queryFn: async () => {
      const response = await getGDSNSchema();
      if (response?.isSuccess) {
        const gdsnSchema = response?.data?.responseItems?.reduce((acc, obj) => {
          const key = obj.fieldName;
          return { ...acc, [key.toLowerCase()]: { ...obj } };
        }, {});

        return Promise.resolve(gdsnSchema);
      } else {
        throw new Error(response?.message);
      }
    },

    staleTime: Infinity,
  });
  const { data, isLoading } = queries;

  return { isLoading, gdsnSchema: data };
};

export const useInvalidateAllGDSNProducts = () => {
  const queryClient = useQueryClient();

  const invalidateAllGDSNReceivedProducts = () => {
    queryClient.invalidateQueries({
      queryKey: getAllGDSNReceivedProductQueryKey(),
    });
  };

  return invalidateAllGDSNReceivedProducts;
};
